export default __webpack_public_path__ + "static/media/auth-background.97cfb6ba.svg";